import collaboratorClient from '.'
import { getAuthHeaders } from 'utils/requests'

let emAndamento = null

/**
 * Obtém o usuário atual do backend e retorna seus dados
 * (vários componentes pedem ao abrir a tela: aproveita a chamada em andamento)
 */
const refreshUserPermissions = async () => {
  if (emAndamento) return emAndamento
  emAndamento = (async () => {
    try {
      const headers = { headers: getAuthHeaders() }
      const response = await collaboratorClient.get('/me', headers)
      return response.data
    } catch (error) {
      console.error('Erro ao atualizar permissões:', error)
      return null
    } finally {
      emAndamento = null
    }
  })()
  return emAndamento
}

export default refreshUserPermissions
